/**
 * Centralized data-testid values for E2E and integration tests.
 * Use this enum in the UI so selectors stay in sync with tests.
 */
// eslint-disable-next-line import/prefer-default-export
export enum ETestId {
  // Auth - Sign In
  SignInEmail = 'signin-email',
  SignInPassword = 'signin-password',
  SignInSubmit = 'signin-submit',

  // Auth - Confirm Sign Up (verification code)
  ConfirmCode = 'confirm-code',
  ConfirmSubmit = 'confirm-submit',
  ConfirmResendCode = 'confirm-resend-code',

  // Create first assistant (onboarding)
  CreateAssistantReferenceName = 'create-assistant-reference-name',
  CreateAssistantBusinessName = 'create-assistant-business-name',
  CreateAssistantService = 'create-assistant-service',
  CreateAssistantSubmit = 'create-assistant-submit',

  // Header / layout
  SelectAgentButton = 'select-agent-button',
  SetupGuidanceDrawer = 'setup-guidance-drawer',

  // Core Behavior (settings)
  CoreBehaviorCustomRules = 'core-behavior-custom-rules',

  // Manage Assistants table
  ManageAssistantsEditButton = 'manage-assistants-edit-button',
  ManageAssistantsSearch = 'manage-assistants-search',

  // Chat (embed / chatbot)
  ChatMessageUser = 'chat-message-user',
  ChatMessageAssistant = 'chat-message-assistant',

  // Knowledge (list item: use KnowledgeSetItem + '-' + knowledgeSetId for row)
  KnowledgeSetItem = 'knowledge-set-item',
  KnowledgeSetDeleteButton = 'knowledge-set-delete-button',
  KnowledgeSetSearch = 'knowledge-set-search',
  KnowledgeSetAddButton = 'knowledge-set-add-button',
  KnowledgeSetName = 'knowledge-set-name',
  KnowledgeSetDescription = 'knowledge-set-description',
  KnowledgeSetTextSnippets = 'knowledge-set-text-snippets',
  KnowledgeSetSubmit = 'knowledge-set-submit',

  // Campaign templates — create campaign modal
  CreateCampaignModalCampaignName = 'create-campaign-modal-campaign-name',
  /** Template picker toggles (Simple Outreach vs Ongoing Sequences) */
  CampaignTemplateTypeOfuOneTime = 'campaign-template-type-ofu-one-time',
  CampaignTemplateTypeOfu = 'campaign-template-type-ofu',

  // Campaign Manager (list + filters)
  CampaignManagerSearch = 'campaign-manager-search',
  CampaignManagerVisibilityFilter = 'campaign-manager-visibility-filter',
  /** Table row: use CampaignListRow + '-' + campaignId */
  CampaignListRow = 'campaign-list-row',
  /** Link on campaign name column: CampaignListRowNameLink + '-' + campaignId */
  CampaignListRowNameLink = 'campaign-list-row-name-link',

  // Campaign OFU manage (draft)
  CampaignOfuManageEdit = 'campaign-ofu-manage-edit',
  /** Toolbar / compact menu — opens go-live dialog while campaign is draft */
  CampaignOfuManageGoLive = 'campaign-ofu-manage-go-live',
  /** Campaign manage toolbar — pause while campaign is active */
  CampaignOfuManagePause = 'campaign-ofu-manage-pause',
  /**
   * Assigned assistant card on OFU Manage → Assistants.
   * Full id: `${CampaignOfuAssistantCard}-${agentId}`.
   */
  CampaignOfuAssistantCard = 'campaign-ofu-assistant-card',

  // Campaign builder
  CampaignBuilderMultiAssistantSwitch = 'campaign-builder-multi-assistant-switch',
  CampaignBuilderMultiAssistantEnableConfirm = 'campaign-builder-multi-assistant-enable-confirm',
  CampaignBuilderMultiAssistantEnableAll = 'campaign-builder-multi-assistant-enable-all',
  CampaignBuilderMultiAssistantClearAll = 'campaign-builder-multi-assistant-clear-all',
  CampaignBuilderNext = 'campaign-builder-next',
  CampaignBuilderCommunicationChannelPhone = 'campaign-builder-communication-channel-phone',
  CampaignBuilderCommunicationChannelEmail = 'campaign-builder-communication-channel-email',
  CampaignBuilderCommunicationChannelText = 'campaign-builder-communication-channel-text',
  CampaignBuilderChannelOfFirstOutreachSelect = 'campaign-builder-channel-of-first-outreach-select',
  CampaignBuilderChannelOfFirstOutreachOptionPhone = 'campaign-builder-channel-of-first-outreach-option-phone',
  CampaignBuilderChannelOfFirstOutreachOptionEmail = 'campaign-builder-channel-of-first-outreach-option-email',
  CampaignBuilderChannelOfFirstOutreachOptionText = 'campaign-builder-channel-of-first-outreach-option-text',
  CampaignBuilderChannelOfFirstOutreachOptionClear = 'campaign-builder-channel-of-first-outreach-option-clear',
  /** INSERT PERSONALIZATION → CONTACT → “+ Add a field” chip */
  CampaignBuilderPersonalizationAddFieldContact = 'campaign-builder-personalization-add-field-contact',
  /** INSERT PERSONALIZATION popover — primary “Add Field” (confirm new contact/location field)  */
  InsertPersonalizationAddFieldModalConfirm = 'insert-personalization-add-field-modal-confirm',
  /** INSERT PERSONALIZATION → LOCATION → “+ Add a field” chip */
  CampaignBuilderPersonalizationAddFieldLocation = 'campaign-builder-personalization-add-field-location',
  // Knowledge v3
  KnowledgeV3Tabs = 'knowledge-v3-tabs',
  KnowledgeV3NewSetButton = 'knowledge-v3-new-set-button',
  KnowledgeV3SetName = 'knowledge-v3-set-name',
  KnowledgeV3SetSubmit = 'knowledge-v3-set-submit',
  KnowledgeV3SetRow = 'knowledge-v3-set-row',
  KnowledgeV3SetDeleteButton = 'knowledge-v3-set-delete-button',
  KnowledgeV3NextReread = 'knowledge-v3-next-reread',
}
